import React from 'react';
export default function Enum(props) {
    let lineRender = null;
    const bcColor = props.bcColor;

    try {
        var vname = props.option[props.value];
        if (vname === '' || vname === undefined) {
            vname = props.value;
        }
        lineRender = vname;
    } catch (e) {
        lineRender = props.value;
    }

    let extraStyle = {};
    const spanClass = '';
    if (bcColor) {
        extraStyle = {fontWeight: 'bold', backgroundColor: bcColor, color: '#FFF'};
    }

    return (
        <div
            className={'newListViewLine ' + props.extraClass}
            onClick={props.onClick}
        >
            {props.icon != undefined && <div className={'listViewIcon ' + props.icon} />}
            <span className={spanClass + (extraStyle ? ' coloredItem' : '')} style={extraStyle} title={vname}>
                {lineRender}
            </span>
        </div>
    );
}
